<template>
  <div class="common-ad">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>首页</BreadcrumbItem>
          <BreadcrumbItem>通用设置</BreadcrumbItem>
          <BreadcrumbItem>开放设置</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">开放设置</div>
      </div>
    </div>
    <div class="box">
      <Form ref="formValidate" :label-width="130" style="width: 1000px">
        <FormItem label="展商中心：" prop="exhibition">
          <Select v-model="exhibition" multiple style="width:500px" filterable>
            <Option v-for="item in exList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="小程序展商登录：" prop="mini">
          <Select v-model="mini" multiple style="width:500px" filterable>
            <Option v-for="item in exList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="展商报名：" prop="centre">
          <Select v-model="centre" multiple style="width:500px" filterable>
            <Option v-for="item in exList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div style="padding: 40px 0 0 130px"><Button style="width: 82px; height: 32px" type="primary" :loading="loading"
          @click="handleSubmit('formValidate')">保存</Button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import config from '@assets/config.json'; // api 
import axios from 'axios';

export default {
  name: "host-common-open",
  data () {
    return {
      type: 5,
      list: [],
      loading: false,
      exhibition: [],
      mini: [],
      centre: [],
      exList: [], // 展会列表
      agentId: "CD4E8CEF-C6F7-4E72-9132-93161B9E8C43",
    };
  },
  computed: {
    ...mapGetters({
      getHeader: 'getHeader'
    }),
    option () {
      return {
        exhibition: this.exhibition,
        centre: this.centre,
        mini: this.mini,
      };
    },
  },
  created () {
    this.init();
  },
  methods: {
    ...mapActions({
      getExByAgentId: "hostSetModule/getExByAgentId",
    }),
    async init () {
      // 获取所有展会
      let res = await this.getExByAgentId({
        AgentId: this.agentId, pageSize: 1000
      });
      if (res && res.items.length > 0) {
        this.exList = res.items;
        console.log(this.exList);
      }
      let exhibition = await this.getAllConfiSettle('exhibition');
      let centre = await this.getAllConfiSettle('centre');
      let mini = await this.getAllConfiSettle('mini');
      console.log('exhibition', exhibition);
      console.log('centre', centre);
      console.log('mini', mini);
      if (exhibition && exhibition[0] && exhibition[0].id) {
        this.exhibition = exhibition[0].exhibitionIds;
      }
      if (centre && centre[0] && centre[0].id) {
        this.centre = centre[0].exhibitionIds;
      }
      if (mini && mini[0] && mini[0].id) {
        this.mini = mini[0].exhibitionIds;
      }
    },
    // 获取展会登录配置
    getAllConfiSettle (type) {
      return new Promise((resolve, reject) => {
        axios.get(`${config.api.reqApi}/api/Exhibition/GetAllConfiSettle?type=${type}`, this.getHeader).then(({ data }) => {
          if (data) {
            resolve(data);
          }
        }).catch((err) => {
          console.log(err.response.data);
        });
      });
    },
    handleSubmit () {
      let opt = [
        {
          "type": "exhibition",
          "exIds": this.exhibition
        },
        {
          "type": "centre",
          "exIds": this.centre
        },
        {
          "type": "mini",
          "exIds": this.mini
        }
      ]

      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      });
      let that = this;
      axios.post(`${config.api.reqApi}/api/Exhibition/ConfigExCreateOrUpdate`, opt, this.getHeader).then(({ data }) => {
        that.loading = false
        if (data && data.successed) {
          that.$Message.success('保存成功')
        } else {
          that.$Message.error('保存失败，请重新尝试')
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.common-ad {
  .header-switch {
    display: flex;
    align-items: center;
    padding: 0 35px 18px 35px;
    background: #fff;

    &-text {
      flex: 1;
      font-size: 14px;
      color: #808080;
    }

    &-box {
      flex: 1;
      text-align: right;
    }
  }

  .box {
    color: #aaa;
    font-size: 14px;
    background-color: #fff;
    margin: 30px;
    padding: 40px;
  }

  /deep/ {
    .ivu-select-multiple .ivu-tag {
      display: block;
    }
  }
}
</style>